import React from 'react';
import PropTypes from 'prop-types';
import ConnectButton from '../../../pages/_banner/ConnectButton';
import Wrapper from '../../../pages/_banner/Wrapper';
import useDialogLauncher from '../../_hooks/useDialogLauncher';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import useRouter from '../../../hooks/useRouter';

ActiveBanner.propTypes = {
  offer: PropTypes.object.isRequired
};

export default function ActiveBanner(props) {
  const { offer, creator } = props;

  const launch = useDialogLauncher();
  const { history } = useRouter();

  function onViewMessage() {
    launch(DialogManager.OfferManage.Config(offer.id, '/manage'));
  }

  function onFindEducators() {
    launch(DialogManager.OfferManage.Config(offer.id, '/invite-populate'));
  }

  function onCancel() {
    launch(DialogManager.OfferCancel.Config(offer.id));
  }

  return (
    <Wrapper
      creator={creator}
      title={(
        <>
          Your offer is active!
        </>
      )}
      subtitle={(
        <>
          Whether you're adding new educators or refining your offer, you can manage
          all your activities below to keep the momentum going.
        </>
      )}
    >
      <div className="flex flex-col sm:flex-row space-x-0 space-y-4 sm:space-x-4 sm:space-y-0">
        <ConnectButton outline={true} onClick={() => history.push('/manage')}>
          Go to messages
        </ConnectButton>
        <ConnectButton onClick={() => history.push('/invite-populate')}>
          Find educators
        </ConnectButton>
      </div>
    </Wrapper>
  );
};
